import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer, FutureLayerSlug } from 'components/features/future/types'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { layerSelector } from 'components/features/future/selectors'
import { FutureLayerPaneBuyCar } from 'components/features/future/FutureLayerPane/BuyCar'
import { FutureLayerPaneBuyHome } from 'components/features/future/FutureLayerPane/BuyHome'
import { FutureLayerPaneGetDegree } from 'components/features/future/FutureLayerPane/GetDegree'
import { FutureLayerPaneGetDivorced } from 'components/features/future/FutureLayerPane/GetDivorced'
import { FutureLayerPaneGetMarried } from 'components/features/future/FutureLayerPane/GetMarried'
import { FutureLayerPaneHaveChild } from 'components/features/future/FutureLayerPane/HaveChild'
import { FutureLayerPaneIncomeChange } from 'components/features/future/FutureLayerPane/IncomeChange'
import { FutureLayerPaneInheritMoney } from 'components/features/future/FutureLayerPane/InheritMoney'
import { FutureLayerPaneLargePurchase } from 'components/features/future/FutureLayerPane/LargePurchase'
import { FutureLayerPaneLoseJob } from 'components/features/future/FutureLayerPane/LoseJob'
import { FutureLayerPaneNewExpense } from 'components/features/future/FutureLayerPane/NewExpense'
import { FutureLayerPaneRecession } from 'components/features/future/FutureLayerPane/Recession'
import { FutureLayerPaneRetireEarly } from 'components/features/future/FutureLayerPane/RetireEarly'
import { FutureLayerPaneSellCar } from 'components/features/future/FutureLayerPane/SellCar'
import { FutureLayerPaneSellHome } from 'components/features/future/FutureLayerPane/SellHome'
import { FutureLayerPaneVacation } from 'components/features/future/FutureLayerPane/Vacation'
import { captureWarning } from 'helpers/errorHelpers'

type FutureLayerDetailsPaneProps = {
  onCancel: () => void
  uid?: FutureLayerUID
  slug?: FutureLayerSlug
}

export const FutureLayerDetailsPane: FC<FutureLayerDetailsPaneProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useStoreSelector((state) => layerSelector(state, props)) as FutureLayer | null
  const slug = layer ? layer.slug : props.slug

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const key = useMemo(() => Math.random(), [layer])
  const paneProps = { uid, onCancel, key }
  if (!slug) {
    // rerender can happens right after delete action, that's why layer can absent
    return null
  }

  /* eslint-disable no-multi-spaces */
  switch (slug) {
    case 'buy_home':       return <FutureLayerPaneBuyHome { ...paneProps } />
    case 'sell_home':      return <FutureLayerPaneSellHome { ...paneProps } />
    case 'buy_car':        return <FutureLayerPaneBuyCar { ...paneProps } />
    case 'sell_car':       return <FutureLayerPaneSellCar { ...paneProps } />
    case 'large_purchase': return <FutureLayerPaneLargePurchase { ...paneProps } />
    case 'vacation':       return <FutureLayerPaneVacation { ...paneProps } />
    case 'get_married':    return <FutureLayerPaneGetMarried { ...paneProps } />
    case 'get_divorced':   return <FutureLayerPaneGetDivorced { ...paneProps } />
    case 'have_child':     return <FutureLayerPaneHaveChild { ...paneProps } />
    case 'retirement':     return <FutureLayerPaneRetireEarly { ...paneProps } />
    case 'get_degree':     return <FutureLayerPaneGetDegree { ...paneProps } />
    case 'lose_job':       return <FutureLayerPaneLoseJob { ...paneProps } />
    case 'recession':      return <FutureLayerPaneRecession { ...paneProps } />
    case 'inherit_money':  return <FutureLayerPaneInheritMoney { ...paneProps } />
    case 'income_change':  return <FutureLayerPaneIncomeChange { ...paneProps } />
    case 'new_expense':    return <FutureLayerPaneNewExpense { ...paneProps } />
    default: {
      captureWarning('Wrong layer', { slug, uid })
      return null
    }
  }
}
